export default __webpack_public_path__ + "static/MBB-logo-fb38c8e698aaf36595f6b6c09185a00b.png";